import { useEffect } from 'react'
import Prism from 'prismjs'

/**
 * Custom hook to initialize and apply Prism.js syntax highlighting
 * @param dependencies - Array of dependencies that should trigger re-highlighting
 */
export const useSyntaxHighlighting = (dependencies: any[] = []) => {
    useEffect(() => {
        // Check if we're in the browser environment
        if (typeof window !== 'undefined') {
            // Highlight all code blocks
            Prism.highlightAll()
        }
    }, dependencies)
}

export default useSyntaxHighlighting